// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 938) return "static/chunks/0465ed09-20fbb99120924756.js";
	if (chunkId === 968) return "static/chunks/968-095e171ce73820d1.js";
	if (chunkId === 314) return "static/chunks/314-422f8b8745a69833.js";
	if (chunkId === 412) return "static/chunks/412-27b81d03e488ab5f.js";
	if (chunkId === 340) return "static/chunks/340-9ab9f45fdfab4828.js";
	if (chunkId === 458) return "static/chunks/458-882e1c346e0fbd4b.js";
	if (chunkId === 793) return "static/chunks/793-c1031f63b73f6588.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 123 ? "65ea55e0" : chunkId) + "." + {"6":"8b39d1decd082c1d","93":"219e628a443b5e38","123":"75930d688bf5df26","142":"3471fdd9bf3c8b9d","177":"9e37f2c23c3df1db","297":"31d37c03a7749c38","393":"fac487852a9cf4a9","428":"1ccb26e66454fa02","557":"b19e8d4995672bd6","558":"1a6cbb10f3e3b642","751":"15c151559c0d3b3b","821":"5d35b51bace07536"}[chunkId] + ".js";
};